import { render } from "./MiNTNewsDetail.vue?vue&type=template&id=9a91667c&scoped=true"
import script from "./MiNTNewsDetail.vue?vue&type=script&lang=js"
export * from "./MiNTNewsDetail.vue?vue&type=script&lang=js"

import "./MiNTNewsDetail.vue?vue&type=style&index=0&id=9a91667c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a91667c"]])

export default __exports__